export const alpha = /^[a-zA-Z_]+( [a-zA-Z_]+)*$/;
export const alphaNumeric = /^[a-zA-Z0-9_]+( [a-zA-Z0-9_]+)*$/;
// eslint-disable-next-line no-useless-escape
export const email = /^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{1,})+$/;
export const phone =
  // eslint-disable-next-line no-useless-escape
  /^(\+?\d{1,2}[\-])?(\+?\d{1,3}[.\s\-]?)?\(?\d{2,3}\)?([.\s\-]?)(\d{3,4}\3\d{4})$/;

export const url =
  // eslint-disable-next-line
  /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|\/\/)(([a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,5}(:[0-9]{1,5})?))(\/.*)?/;
/**
 * 'multiLink' REGEX checks the link matches one of these formats, case-insensitively:
 *   - string is a URL format
 *     - has a `.` in it, at minimum, but
 *     - may have zero or more other characters before or after it
 *   - string is an email format
 *     - starts with `mailto:`, and
 *     - one or more other characters follows it
 *   - string is a telephone format
 *     - starts with `tel:`, and
 *     - one or more other characters follows it
 * See regexr.com/53efh for an explanation and a way to play around with string matches.
 * */
export const multiLink = /(.+\..+|^mailto:.+|^tel:.+)/i;
